import styled from 'styled-components'
import { Border, Colors, Spacing } from '../../styles'

const Track = styled.button<{ $checked: boolean }>`
    position: relative;
    flex: 0 0 auto;
    width: ${Spacing._48};
    height: ${Spacing._24};
    padding: ${Spacing._2};
    border: ${Border.stroke.medium} solid
        ${({ $checked }) => ($checked ? Colors.control.primary.stroke : Colors.background.border)};
    border-radius: ${Spacing._16};
    background: ${({ $checked }) => ($checked ? Colors.control.primary.bg : Colors.background.sub)};
    cursor: pointer;

    &:disabled {
        cursor: default;
        opacity: 0.6;
    }

    &:focus-visible {
        outline: ${Border.stroke.large} solid ${Colors.control.secondary.highlight};
        outline-offset: ${Spacing._2};
    }
`

const Knob = styled.span<{ $checked: boolean }>`
    display: block;
    width: ${Spacing._16};
    height: ${Spacing._16};
    border-radius: 50%;
    background: ${({ $checked }) => ($checked ? Colors.control.primary.label : Colors.background.white)};
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    transform: translateX(${({ $checked }) => ($checked ? Spacing._24 : '0')});
    transition: transform 120ms ease;
`

interface GTSwitchProps {
    label: string
    checked: boolean
    onChange: (checked: boolean) => void
    disabled?: boolean
    testId?: string
}

const GTSwitch = ({ label, checked, onChange, disabled, testId }: GTSwitchProps) => (
    <Track
        type="button"
        role="switch"
        aria-label={label}
        aria-checked={checked}
        data-testid={testId}
        $checked={checked}
        disabled={disabled}
        onClick={() => onChange(!checked)}
    >
        <Knob $checked={checked} />
    </Track>
)

export default GTSwitch
